import { render, staticRenderFns } from "./browserdetectionmodal.vue?vue&type=template&id=9c612370&scoped=true"
import script from "./browserdetectionmodal.vue?vue&type=script&lang=js"
export * from "./browserdetectionmodal.vue?vue&type=script&lang=js"
import style0 from "./browserdetectionmodal.vue?vue&type=style&index=0&id=9c612370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c612370",
  null
  
)

export default component.exports